export default class PendingDocumentStore {
  // The rowKey of the document is the id
  private static numberOpen: number = 0;
  private static requests: Map<string, XMLHttpRequest> = new Map<
    string, XMLHttpRequest>();
  private static abortedRequests: string[] = [];

  public static isDocumentPending(id: string): boolean {
    return PendingDocumentStore.requests.has(id);
  }
  
  public static getNumberOfPendingDocuments(): number {
    return PendingDocumentStore.numberOpen;
  }
  
  public static addPendingDocument(id: string, request: XMLHttpRequest): void {
    PendingDocumentStore.requests.set(id, request);
    PendingDocumentStore.numberOpen++;
  }

  public static removePendingDocument(id: string): void {
    if (PendingDocumentStore.requests.has(id)) {
      PendingDocumentStore.requests.delete(id);
      PendingDocumentStore.numberOpen = Math.max(0, PendingDocumentStore.numberOpen - 1);
    }
  }

  public static clearAllPendingDocuments(): void {
    PendingDocumentStore.abortAllRequests();
  }

  private static abortAllRequests(): void {
    PendingDocumentStore.requests.forEach((request, id) => {
      request.abort();
      PendingDocumentStore.requests.delete(id);
      PendingDocumentStore.abortedRequests.push(id);
      PendingDocumentStore.numberOpen = Math.max(0, PendingDocumentStore.numberOpen - 1);
    });
  }

  public static isRequestAborted(id: string): boolean {
    return PendingDocumentStore.abortedRequests.includes(id) && !PendingDocumentStore.requests.has(id);
  }

  public static deleteAbortedRequest(id: string): void {
    const index = PendingDocumentStore.abortedRequests.indexOf(id);
    if (index > -1) {
      PendingDocumentStore.abortedRequests.splice(index, 1);
    }
  }

  public static clearAllAbortedRequest(): void {
    PendingDocumentStore.abortedRequests = [];
  }
}
  